/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, ConfigProvider, Flex, Layout, Menu } from 'antd';
import React, { useState } from 'react';
import {
  HomeOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UnorderedListOutlined,
  FileOutlined,
  ContainerOutlined,
  UserOutlined,
  AppstoreOutlined,
  ClockCircleOutlined,
  SoundOutlined,
} from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getUserInfo } from '../reducers/User/actions';

const { Sider } = Layout;

const SiderBox: React.FC = () => {
  const [collapsed, setCollapsed] = useState(true);
  const navigate = useNavigate();
  const current = window.location.pathname.split('/')[1];
  const userInfo: any = useSelector(getUserInfo);
  const isAdmin = userInfo?.role === 'Admin';

  const items = [
    {
      key: 'account-list',
      icon: <HomeOutlined style={{ fontSize: 16 }} />,
      label: <Link to={`/account-list`}>Account List</Link>,
      onClick: () => navigate('/account-list'),
    },
    {
      key: 'queue-list',
      icon: <UnorderedListOutlined style={{ fontSize: 16 }} />,
      label: <Link to={`/queue-list`}>Queue List</Link>,
      onClick: () => navigate('/queue-list'),
    },
    {
      key: 'schedulers',
      icon: <ClockCircleOutlined style={{ fontSize: 16 }} />,
      label: <Link to={`/schedulers`}>Schedulers</Link>,
      onClick: () => navigate('/schedulers'),
    },
    {
      key: 'file-management',
      icon: <FileOutlined style={{ fontSize: 16 }} />,
      label: <Link to={`/file-management`}>File Management</Link>,
      onClick: () => navigate('/file-management'),
    },
    {
      key: 'access-management',
      icon: <ContainerOutlined style={{ fontSize: 16 }} />,
      label: <Link to={`/access-management`}>Access Management</Link>,
      onClick: () => navigate('/access-management'),
    },
    {
      key: 'templatisation-engine',
      icon: <AppstoreOutlined style={{ fontSize: 16 }} />,
      label: <Link to={`/templatisation-engine`}>Templatisation Engine</Link>,
      onClick: () => navigate('/templatisation-engine'),
    },
    {
      key: 'voicebot-templates',
      icon: <SoundOutlined style={{ fontSize: 16 }} />,
      label: <Link to={`/voicebot-templates`}>Voicebot Templates</Link>,
      onClick: () => navigate('/voicebot-templates'),
    },
    ...(isAdmin
      ? [
          {
            key: 'user-management',
            icon: <UserOutlined style={{ fontSize: 16 }} />,
            label: <Link to={`/user-management`}>User Management</Link>,
            onClick: () => navigate('/user-management'),
          },
        ]
      : []),
  ];

  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            itemBg: '#F6F8FA',
          },
        },
      }}
    >
      <Sider
        collapsed={collapsed}
        width="17%"
        style={{ paddingTop: 24, color: '#fff', maxHeight: '100vh', overflowY: 'auto', backgroundColor: '#F6F8FA' }}
        theme="light"
      >
        <Flex vertical style={{ height: '100%' }} justify="space-between">
          <Menu selectedKeys={[current]} mode="inline" items={items} />
          <div style={{ height: 40, paddingInline: 16 }}>
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{ fontSize: '16px' }}
            />
          </div>
        </Flex>
      </Sider>
    </ConfigProvider>
  );
};

export default SiderBox;
